<div class="section">
    <!-- Loader -->
    <div class="progress-spinner" *ngIf="isLoading">
        <p-progressSpinner></p-progressSpinner>
    </div>

    <!-- header section -->
    <div class="header-container">
        <div class="col-lg-12 col-md-12 col-sm-12 pad0">
            <div>
                <span><img src="assets/images/file.png" class="file-img"></span>&nbsp;
                <span class="reportDisHeader">Report Discrepancy Form</span>
            </div>
            <div class="padL-30 padR-30 headrSub">
                The report a discrepancy tool is to be used to report known publication errors only,<br>
                If you have a technical question please see our&nbsp;
                <a class="privacyCls" (click)="setFAQ()">Technical Knowledge Center.</a>
            </div>
        </div>
    </div>
    <hr>
    <div class="sec-cntr row">
        <!-- fields -->
        <div class="col-lg-6 col-md-6 col-sm-6 pad-L0">
            <div>
                <label class="label-view">Publication Number</label>
                <input type="text" class="form-control" [(ngModel)]="pubNumber" [readonly]="true">
            </div>
            <div class="mar-T20">
                <label class="label-view">ATA Number</label>
                <input type="text" class="form-control" [(ngModel)]="ataNumber" [readonly]="true">
            </div>
            <div class="mar-T20">
                <label class="label-view">Discrepancy Category</label>&nbsp;<span class="mandatory">*</span>
                <select class="form-select" [(ngModel)]="categoryList" name="cateType"
                    (change)="onCategorySelected(categoryList)">
                    <option value="select" disabled>Select Category</option>
                    <option *ngFor='let option of categoryData' [ngValue]="option">{{option.description}}
                    </option>
                </select>
            </div>
            <div class="mar-T20 width-F">
                <Span class="pageLeft">
                    <label class="label-view">Page Number</label>&nbsp;<span class="mandatory">*</span>
                    <input type="text" class="form-control" placeholder="Type here..." autocomplete="off"
                        [(ngModel)]="pageNumber" [maxLength]="pageNumLen" 
                        [ngStyle]="{'border': pageNumbError ? '1px solid red' : '1px solid #ccc'  }"
                        (keypress)="onKeyPressEvent($event)">
                </Span>
                <Span class="paraRight">
                    <label class="label-view">Paragraph Number</label>
                    <input type="text" class="form-control" placeholder="Type here..." autocomplete="off"
                        [(ngModel)]="paragraph" [maxLength]="paraLen" 
                        [ngStyle]="{'border': paraNumbError ? '1px solid red' : '1px solid #ccc'  }"
                        (keypress)="onKeyPressEvent($event)">
                </Span>
            </div>
            <div class="mar-T20">
                <label class="label-view">Discrepancy and/or comments</label>&nbsp;<span class="mandatory">*</span>
                <textarea class="form-control" rows="4" placeholder="Type here..." [(ngModel)]="comments"
                    [maxLength]="commentsLen" 
                    [ngStyle]="{'border': commentsError ? '1px solid red' : '1px solid #ccc'  }"
                    (keypress)="onKeyPressEvent($event)"></textarea>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 pad-L0 pad-R0">
            <div>
                <label class="label-view">Revision Number</label>
                <input type="text" class="form-control" [(ngModel)]="revNumber" [readonly]="true">
            </div>
            <div class="mar-T20">
                <label class="label-view">Revision Date</label>
                <input type="text" class="form-control" [(ngModel)]="revDate" [readonly]="true">
            </div>
            <div class="mar-T20">
                <label class="label-view">Other</label>&nbsp;<span class="mandatory" *ngIf="!isOther">*</span>
                <input type="text" class="form-control" placeholder="Type here..." autocomplete="off"
                    [(ngModel)]="other" [readonly]="isOther" [maxLength]="otherLen"
                    [ngStyle]="{'border': othersError ? '1px solid red' : '1px solid #ccc'  }"
                    (keypress)="onKeyPressEvent($event)">
            </div>
            <div class="mar-T20 width-F">
                <Span class="pageLeft">
                    <label class="label-view">Table No.</label>
                    <input type="text" class="form-control" placeholder="Type here..." autocomplete="off"
                        [(ngModel)]="tableNumber" [maxLength]="tableLen" 
                        [ngStyle]="{'border': tablNumbError ? '1px solid red' : '1px solid #ccc'  }"
                        (keypress)="onKeyPressEvent($event)">
                </Span>
                <Span class="paraRight">
                    <label class="label-view">Figure No.</label>
                    <input type="text" class="form-control" placeholder="Type here..." autocomplete="off"
                        [(ngModel)]="figNumber" [maxLength]="figureLen" 
                        [ngStyle]="{'border': figuNumbError ? '1px solid red' : '1px solid #ccc'  }"
                        (keypress)="onKeyPressEvent($event)">
                </Span>
            </div>
        </div>
        <!-- buttons -->
        <div class="col-lg-12 col-md-12 col-sm-12 pad-L0 pad-R0 disc-rep-btn-content">
            <div class="alert alert-warning" role="alert" *ngIf="alertWarn">{{alertWarn}}</div>
            <div class="alert alert-success" role="alert" *ngIf="ifAlertMsg">{{alertMsg}}</div>
            <div class="alert alert-warning" role="alert" *ngIf="valErrorMsg">{{valErrorMsg}}</div>
            <div class="width-F">
                <div class="privac-left">
                    We use this information in strict accrodance with our&nbsp;
                    <a class="privacyCls" (click)="setPrivacy()">Privacy Policy</a>
                </div>
                <div class="popup-btn-right" align="right">
                    <button type="button" class="btn btn-white-cls cancelRep mar-R10"
                        (click)="cancelPopup()">CANCEL</button>
                    <button type="button" (click)="clickSubmitEvent()" [disabled]="!validationFields() || disableSubmit"
                        [ngClass]="(!validationFields() || disableSubmit) ? 'btn rpotDisBtn btn-gray-cls' : 'btn rpotDisBtn btn-blue-cls'">SUBMIT</button>
                </div>
            </div>
        </div>
    </div>
</div>